import type { ErrorSeverity } from "./ErrorSeverity";

type ExceptionProps = {
  errorSeverity: ErrorSeverity;
  useErrorBoundary: boolean;
  name: string;
  message: string;
  response: Response;
  stack?: string;
}

export abstract class Exception extends Error {
  response: Response;
  errorSeverity: ErrorSeverity;
  useErrorBoundary: boolean;
  responseBody?: string;

  public constructor({ errorSeverity, useErrorBoundary, name, message, response, stack }: ExceptionProps) {
    super(name);
    this.message = message;
    this.response = response;
    this.stack = stack;
    this.errorSeverity = errorSeverity;
    this.useErrorBoundary = useErrorBoundary;
  }
}
